<template>
    <v-container class="evaluation-url-component gray">
        <template v-if="available">
            <v-row v-if="availableEvaluation" >
                <v-col>
                    <v-card
                        class="evaluation-card mt-5"
                        v-if="!isEmptyObj(getEvaluation)"
                    >
                        <v-card-text class="pa-0">
                            <v-container>
                                <v-row>
                                    <v-col class="imag-res" cols="auto">
                                        <img
                                            src="@/assets/images/placeholder-url-evaluation.png"
                                            alt
                                        />
                                    </v-col>
                                    <v-col
                                        class="evaluation-card__information-block"
                                    >
                                        <!-- header -->
                                        <v-row
                                            no-gutters
                                            justify="space-between"
                                        >
                                            <v-col cols="auto" class="">
                                                <p
                                                    class="evaluation-card__grade d-inline grey lighten-4"
                                                >
                                                    {{ grade }}
                                                </p>
                                                <p
                                                    class="evaluation-card__subject d-inline"
                                                >
                                                    {{ subject }}
                                                </p>
                                            </v-col>
                                            <v-col
                                                cols="auto"
                                                class="container-status-date"
                                            >
                                                <p
                                                    class="evaluation-card__status d-inline text-capitalize cardTitle--text ml-sm-3 ml-md-10"
                                                >
                                                    {{ status }}
                                                </p>
                                                <p
                                                    class="evaluation-card__date d-inline cardTitle--text ml-sm-5 ml-md-5"
                                                >
                                                    {{ date }}
                                                </p>
                                            </v-col>
                                        </v-row>
                                        <!-- title -->
                                        <v-row no-gutters>
                                            <v-col
                                                cols="12"
                                                class="title-wrapper mt-sm-3"
                                            >
                                                <p
                                                    class="evaluation-card__code text-capitalize text-uppercase romaGreyOne--text"
                                                >
                                                    {{ code }}
                                                </p>
                                                <h1
                                                    class="evaluation-card__title text-uppercase cardTitle--text"
                                                >
                                                    {{ name }}
                                                </h1>
                                            </v-col>
                                        </v-row>
                                        <!-- button -->
                                        <v-row
                                            no-gutters
                                            justify="end"
                                            class="mt-sm-2"
                                        >
                                            <v-col class="col-sm-12">
                                                <button
                                                    id="search"
                                                    class="text-capitalize"
                                                    :class="
                                                        disable
                                                            ? 'btn-disable'
                                                            : 'btn-start'
                                                    "
                                                    @click="loadDetail()"
                                                    :disabled="disable"
                                                >
                                                    <span v-if="!disable">
                                                        {{ textBtn }}
                                                    </span>
                                                    <span v-else
                                                        >Procesando...</span
                                                    >
                                                </button>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-else class="justify-center align-center loading-component">
                <v-col cols="auto">
                    <RomaMessages 
                        message="<h2>No se encuentra evaluación válida para el usuario.</h2><h3>Contáctese con soporte Roma: +56 9 3458 0660</h3>"
                        width="250px"
                        isIcon="true"
                        imageName="404browser.svg"
                    />
                </v-col>
            </v-row>
        </template>
        <template v-else>
            <v-row class="justify-center align-center loading-component">
                <v-col cols="auto" v-if="message === null">
                    <RomaWait message="Cargando información" width="250px" />
                </v-col>
                <v-col cols="auto" v-else class="text-center">
                    <RomaMessages
                        v-if="!noAvailable"
                        :message="message"
                        width="250px"
                        :isIcon="isIcon"
                    />
                    <RomaNoAvailable
                        v-if="noAvailable"
                        :message="message"
                        position="top"
                    />
                    <router-link
                        to="/resultados"
                        v-if="evaluated"
                        class="view-results"
                        >Ver Resultados</router-link
                    >
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import RomaMessages from "../../components/commons/RomaMessages";
import RomaWait from "../../components/commons/RomaWait";
import RomaNoAvailable from "../../components/commons/RomaNoAvailable";
export default {
    name: "evaluation-init",
    data() {
        return {
            evaluationDataObj: {},
            urlEvaluation: null,
            message: null,
            disable: false,
            available: false,
            isIcon: true,
            noAvailable: false,
            ma: null,
            evaluated: false
        };
    },
    components: {
        RomaMessages,
        RomaWait,
        RomaNoAvailable
    },
    computed: {
        ...mapGetters({
            getEvaluation: "getEvaluation",
            institutionId: "getInstitutionId",
            getUserData: "getUserData",
            getLogged: "getLogged",
            getMa: "getMa",
            getSessionActive: "getSessionActive",
            getIsPreBasicAndLinkEmbebed: "getIsPreBasicAndLinkEmbebed",

        }),
        status() {
            return typeof this.getEvaluation.content.medicionAsignadaTO !==
                "undefined"
                ? this.capitalizeFirstLetter(
                      this.getEvaluation.content.estadoEvaluacion
                  )
                : "";
        },
        code() {
            return typeof this.getEvaluation.content.medicionAsignadaTO !==
                "undefined"
                ? this.getEvaluation.content.medicionAsignadaTO.medicionTO.code
                : "";
        },
        name() {
            return typeof this.getEvaluation.content.medicionAsignadaTO !==
                "undefined"
                ? this.getEvaluation.content.medicionAsignadaTO.medicionTO.name
                : "";
        },
        subject() {
            return typeof this.getEvaluation.content.medicionAsignadaTO !==
                "undefined"
                ? this.capitalizeFirstLetter(
                      this.getEvaluation.content.medicionAsignadaTO.asignaturaTO
                          .name
                  )
                : "";
        },
        grade() {
            return typeof this.getEvaluation.content.medicionAsignadaTO !==
                "undefined"
                ? this.capitalizeFirstLetter(
                      this.getEvaluation.content.medicionAsignadaTO.cursoTO
                          .categoryTO.abbreviation
                  )
                : "";
        },
        date() {
            const date = this.getEvaluation.content.medicionAsignadaTO.fechaFin;
            const dateArr = date.split("-");
            return `${dateArr[0]}/${dateArr[1]}/${dateArr[2]}`;
        },
        textBtn() {
            let text = null;
            switch (this.getEvaluation.content.estadoEvaluacion) {
                case "EN PROCESO":
                    text = "Continuar";
                    break;
                case "PENDIENTE":
                    text = "Iniciar";
                    break;
                default:
                    text = "Iniciar";
                    break;
            }
            return text;
        },
        availableEvaluation() {
            return this.getEvaluation && this.getEvaluation.content && (this.getEvaluation.content.medicionAsignadaTO.estado !== "EN PROCESO") ? false : true;
        }
    },
    created() {
        this.setEnablePdfPoll({ enablePollMobile: false });
        if (!this.getLogged) {
                this.auth();

        } else {
                this.actionSetUser().then(data => {
                    if (data.data.idMedicionAsignada === null) {
                        this.message = `<h1>No se encuentra evaluación válida para el usuario.</h1><h2>Contáctese con soporte Roma: +56 9 3458 0660</h2>`;
                        this.noAvailable = true;
                    } else {
                        this.loadEvaluation();
                    }
                });
        }
    },
    mounted() {
        this.setEnablePdfPoll(false);
        if (typeof this.$route.query.ma !== "undefined") {
            this.setMedA(this.$route.query.ma);
        }
    },
    methods: {
        ...mapActions({
            setEvaluation: "setEvaluation",
            actionSetUser: "actionSetUser",
            setEvaluationDetail: "setEvaluationDetail",
            setUserLocal: "setUserLocal",
            setLogged: "setLogged",
            setMa: "setMa",
            setSessionActive: "setSessionActive",
            setAnswers: "setAnswers",
            setInitializedQuiz: "setInitializedQuiz",
            setEnablePdfPoll: "setEnablePdfPoll",
            setSentEvaluation: "setSentEvaluation",
            setFinishedQuiz: "setFinishedQuiz",
            setIsPreBasicAndLinkEmbebed: "setIsPreBasicAndLinkEmbebed",
            setLinkEmbebed: "setLinkEmbebed",
            resetEvaluation: "resetEvaluation",
            resetUser: "resetUser",
            resetPdf: "resetPdf",
            resetTimer: "resetTimer",
            setTimeEndRemainingZero: "setTimeEndRemainingZero"
        }),
        /**
         * This function call service api getUserData and set in the store response
         */
        auth() {
            this.actionSetUser().then(response => {
                if (typeof response.data !== "undefined") {
                    this.loadEvaluation();
                    this.setLogged(true);
                } else {
                    this.setUserNull();
                    this.$router.push({ name: "Disconnect" });
                }
            });
        },
        capitalizeFirstLetter(string) {
            return (
                string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
            );
        },
        /**
         * This function call service api evaluation and set in the store response
         * */
        loadEvaluation() {
            if (
                typeof this.getUserData.fullName !== "undefined" &&
                this.getUserData.fullName !== null
            ) {
                this.setEvaluation({
                    idInstitucion: this.getUserData.institutionContext
                        .institutionId,
                    idMedicionAsignada: this.getMa,
                    idPeriodo: this.getUserData.institutionContext.periodId,
                    idPersona: this.getUserData.personId
                })
                    .then(response => {
                        if (response.data.status.code === 1) {
                            switch (response.data.content.estadoEvaluacion) {
                                case "EN PROCESO":
                                    this.available = true;
                                    this.evaluated = false;
                                    break;
                                case "PENDIENTE":
                                    this.available = true;
                                    this.evaluated = false;
                                    break;
                                case "EVALUADA":
                                    this.evaluated = false;
                                    this.message =
                                        "<h1>La medición ya se encuentra evaluada.</h1>";
                                    this.evaluated = 
                                        (response.data.content.alumnoPresenteMedicion === true 
                                            && 
                                        response.data.content.medicionAsignadaTO.enviarResultados !== "NO_ENVIAR"
                                            &&
                                        response.data.content.medicionAsignadaTO.estado === "TOMADA" )
                                            ||
                                        response.data.content.medicionAsignadaTO.mostrarRespuestas;
                                    if(this.evaluated) { 
                                        this.setDetailResults();
                                        this.logout(900000);
                                    }else{
                                        this.logout();
                                    }                                    
                                    break;
                                case "COMPLETADA":
                                    this.evaluated = false;
                                    this.setDetailResults();
                                    this.message =
                                        "<h1>La medición ya se encuentra completada.</h1>";
                                    this.logout();
                                    break;
                                case "COMPLETA":
                                    this.message =
                                        "<h1>La medición ya se encuentra completada.</h1>";
                                    this.evaluated = false;
                                    this.logout();
                                    break;
                            }

                            if (this.getMa !== null) {
                                this.setMa(this.getMa);
                            }

                            // const abbreviation = response.data.content.medicionAsignadaTO.cursoTO.categoryTO.abbreviation; 
                            const tipoInstrumento = response.data.content.medicionAsignadaTO.tipoInstrumento; 
                            const tipoRespuesta = response.data.content.medicionAsignadaTO.tipoRespuesta; 
                            const linkEmbebed = response.data.content.form.linkResource; 

                            //verificar si es usuario NT (prekinder) 
                            //check if tipo instrumento  == 1 y tipo respuesta == 1
                            // show alternatives de colores 

                            // if (abbreviation.includes("NT")) {
                                if (tipoInstrumento == 1 && tipoRespuesta == 1) {
                                    // console.log("is prebasiccc");
                                    this.setIsPreBasicAndLinkEmbebed(true);
                                    if(linkEmbebed.includes("genial.ly")) {
                                        const shortLink = linkEmbebed.substr(0,47);
                                        this.setLinkEmbebed(shortLink);
                                        // console.log("s" ,shortLink);  
                                    }else{
                                        this.setLinkEmbebed(linkEmbebed);
                                        // console.log("l",linkEmbebed);
                                    }
                                    // console.log("getIsPreBasicAndLinkEmbebed" ,this.getIsPreBasicAndLinkEmbebed);                     
                                }
                            // }


                        } else if (response.data.status.code === 2) {
                            switch (response.data.content.code) {
                                case "ROMA_EXCEPTION":
                                    this.message = `<h1>${response.data.content.message}.</h1><h2>Contáctese con soporte Roma: +56 9 3458 0660</h2>`;
                                    this.noAvailable = true;
                                    break;
                            }
                        } else if (response.data.status.code === 3) {
                            switch (response.data.content.code) {
                                case 2:
                                    this.message = `<h1>${response.data.content.message}.</h1><h2>Contáctese con soporte Roma: +56 9 3458 0660</h2>`;
                                    this.noAvailable = true;
                                    break;
                            }
                        }
                    })
                    .catch(error => {
                        if (error.status === 404) {
                            this.message = error.data.message;
                        }
                        if (error.data.status.code === 3) {
                            switch (error.data.content.code) {
                                case 2:
                                    this.message = `<h1>${error.data.content.message}.</h1><h2>Contáctese con soporte Roma: +56 9 3458 0660</h2>`;
                                    this.noAvailable = true;
                                    break;
                            }
                        }
                    });
            } else {
                this.message = `<h1>El usuario no tiene acceso a la evaluación.  Cierre sesión para ingresar con otro usuario.</h1><h2>Contáctese con soporte Roma: +56 9 3458 0660</h2>`;
                this.noAvailable = true;
            }
        },
        logout(time=30000) {
            setTimeout(()=> {
                this.resetUser();
                this.resetEvaluation();
                this.resetPdf();
                this.resetTimer();
                this.setTimeEndRemainingZero(false);
                window.location = process.env.VUE_APP_ROMA_PLANNER_API_URL+'/logout';
            },time)
        },
        /**
         * This function handle then press button in de card action continue, start and call api service evaluation
         * details and set response in the store
         * */
        async loadDetail() {
            this.disable = true;
            this.setSentEvaluation(false);
            this.setFinishedQuiz(false);
            if (this.getMa === null) {
                this.message = `<h1>No se encuentra evaluación válida para el usuario.</h1><h2>Contáctese con soporte Roma: +56 9 3458 0660</h2>`;
                this.noAvailable = true;
            } else {
                this.disable = true;
                const formId = this.getEvaluation.content.form.idForma;

                // const abbreviation = this.getEvaluation.content.medicionAsignadaTO.cursoTO.categoryTO.abbreviation; 
                const tipoInstrumento = this.getEvaluation.content.medicionAsignadaTO.tipoInstrumento; 
                const tipoRespuesta = this.getEvaluation.content.medicionAsignadaTO.tipoRespuesta; 
                const linkEmbebed = this.getEvaluation.content.form.linkResource; 
                if (
                    this.getSessionActive.personId !== this.getUserData.personId
                ) {
                    this.resetEvaluation();
                    this.setTimeEndRemainingZero(false);
                    this.setSessionActive({
                        medicionAsignada: this.getMa,
                        personId: this.getUserData.personId
                    });
                }

                if (
                    this.getSessionActive.personId ===
                        this.getUserData.personId &&
                    this.getSessionActive.medicionAsignada !== this.getMa
                ) {
                    this.resetEvaluation();
                    this.setTimeEndRemainingZero(false);
                    this.setSessionActive({
                        medicionAsignada: this.getMa,
                        personId: this.getUserData.personId
                    });
                }
                await this.setEvaluationDetail({
                    formId: formId,
                    idInstitucion: this.getUserData.institutionContext
                        .institutionId,
                    idMedicionAsignada: this.getMa,
                    idPeriodo: this.getUserData.institutionContext.periodId,
                    idPersona: this.getUserData.personId
                })
                    .then(() => {
                        this.$router.push({
                            path: "/evaluaciones"
                        });
                    })
                    .catch(e => {
                        this.evaluated = false;
                        console.info(e);
                    });

                // console.log(abbreviation);
                // if (abbreviation.includes("NT")) {
                if (tipoInstrumento == 1 && tipoRespuesta == 1) {
                    // console.log("is prebasiccc");
                    this.setIsPreBasicAndLinkEmbebed(true);
                    if(linkEmbebed.includes("genial.ly")) {
                        const shortLink = linkEmbebed.substr(0,47);
                        this.setLinkEmbebed(shortLink);
                        // console.log("s" ,shortLink);  
                    }else{
                        this.setLinkEmbebed(linkEmbebed);
                        // console.log("l",linkEmbebed);
                    }
                    // console.log("getIsPreBasicAndLinkEmbebed" ,this.getIsPreBasicAndLinkEmbebed);                     
                }
            // }


            }
        },
        async setDetailResults() {
            await this.setEvaluationDetail({
                formId: this.getEvaluation.content.form.idForma,
                idInstitucion: this.getUserData.institutionContext
                    .institutionId,
                idMedicionAsignada: this.getMa,
                idPeriodo: this.getUserData.institutionContext.periodId,
                idPersona: this.getUserData.personId
            }).then(() => {
                this.evaluated = true;
            });
        },
        setMedA(ma) {
            this.setMa(ma);
        },
        setUserNull() {
            this.setUserLocal({});
        }
    }
};
</script>

<style lang="scss">
.evaluation-url-component {
    height: 100%;
    .evaluation-card {
        padding: 15px 20px 15px 20px;
        transition: box-shadow 0.5s ease;
        background: #ffffff 0 0 no-repeat padding-box;
        box-shadow: 0 9px 19px #00000029 !important;
        border-radius: 14px !important;
        opacity: 1;
        .start-btn {
            width: max-content !important;
            height: auto;
            padding: 16px 56px !important;
            border-radius: 9px !important;
            .v-btn__content {
                font-size: 14px;
            }
        }
        &__information-block {
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: max-content 1fr max-content;
            .title-wrapper {
                align-self: center;
            }
        }
        &__title {
            font-size: 22px;
            font-weight: lighter;
        }
        &__grade {
            border-radius: 50%;
            padding: 5px 7px;
            margin-right: 0.5rem;
        }
        &__subject {
        }
        &__state {
        }
        &__date {
        }
        &__code {
        }
    }
}

@media (max-width: 599px) {
    .imag-res {
        display: none;
    }
    .text-capitalize {
        padding-right: 0 !important;
    }
    .evaluation-card {
        .text-capitalize.start-btn {
            padding-right: 9px !important;
            margin-top: 10px !important;
            padding-bottom: 0 !important;
        }
        .start-btn {
            width: max-content !important;
            height: auto;
            padding-right: 0 !important;
            border-radius: 9px !important;
            background-color: white !important;
            color: #e97c21;
            .v-btn__content {
                font-size: 14px;
                background-color: white !important;
                color: #e97c21;
                padding-right: 0 !important;
            }
        }
        &__title {
            font-size: 14px;
            font-weight: lighter;
        }
        &__grade {
            border-radius: 50%;
            padding: 5px 7px;
            margin-right: 0.5rem;
        }
        &__subject {
            font-size: 14px;
            font-weight: lighter;
        }
        &__status {
            font-size: 12px;
            font-weight: lighter;
            margin-right: 5px;
        }
        &__date {
            font-size: 12px;
            font-weight: lighter;
        }
        &__code {
            font-size: 14px;
            font-weight: lighter;
        }
        .container-status-date {
            position: absolute;
            right: 12px;
            top: 15px;
        }
        .title-wrapper {
            margin-top: 15px;
        }
        .evaluation-card__title {
            font-size: 18px !important;
            font-weight: lighter;
            margin-bottom: 5px;
        }
    }
}

.btn-start {
    border-radius: 10px;
    position: absolute;
    bottom: 30px;
    right: 30px;
    padding: 15px 10px !important;
    width: 180px;
    height: 50px !important;
    font-size: 17px !important;
    background-color: #e97c21 !important;
    color: #ffffff !important;
    box-shadow: none !important;
}

.btn-disable {
    border-radius: 10px;
    position: absolute;
    bottom: 30px;
    right: 30px;
    padding: 15px 10px !important;
    width: 180px;
    height: 50px !important;
    font-size: 17px !important;
    background-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.26);
    box-shadow: none !important;
}

@media (max-width: 800px) {
    .btn-start {
        border-radius: 0;
        position: absolute;
        bottom: 7px;
        right: 5px;
        padding: 2px !important;
        width: 100px;
        height: 50px !important;
        font-size: 16px !important;
        background-color: transparent !important;
        color: #3a8fce !important;
        box-shadow: none !important;
    }
    .btn-disable {
        border-radius: 0;
        position: absolute;
        bottom: 7px;
        right: 5px;
        padding: 2px !important;
        width: 100px;
        height: 50px !important;
        font-size: 16px !important;
        background-color: transparent !important;
        color: rgba(0, 0, 0, 0.26);
        box-shadow: none !important;
    }
}
.view-results {
    text-align: center;
    text-decoration: none;
    a {
        font-size: 1.5em;
        color: #3a8fce !important;
        text-align: center;
    }
    font-size: 1.5em;
    color: #3a8fce !important;
}
</style>
